import React from "react";

/**
 * Extra glyphs for the marketing pages, drawn on the same 24px grid and with
 * the same 1.7 stroke as landingArt.jsx, so an icon lifted from either file
 * sits happily beside the other.
 */
const glyph = (paths) => () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {paths}
  </svg>
);

export const IconSprint = glyph(
  <>
    <path d="M4 12a8 8 0 1 1 2.6 5.9" />
    <path d="M4 12l2.6-2.4M4 12l2.7 2.6" />
    <path d="M12 8v4.4l3 1.8" />
  </>
);

export const IconTarget = glyph(
  <>
    <circle cx="12" cy="12" r="8" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="12" cy="12" r="1" />
  </>
);

export const IconFilter = glyph(
  <>
    <path d="M4 6h16l-6.2 7v5.4L10.2 20v-7z" />
  </>
);

export const IconHistory = glyph(
  <>
    <path d="M4 12a8 8 0 1 0 2.4-5.7" />
    <path d="M4 5v3.6h3.6" />
    <path d="M12 8v4.4l3 1.8" />
  </>
);

export const IconTag = glyph(
  <>
    <path d="M4 11.4V5a1 1 0 0 1 1-1h6.4a1 1 0 0 1 .7.3l7.3 7.3a1 1 0 0 1 0 1.4l-6.4 6.4a1 1 0 0 1-1.4 0L4.3 12.1a1 1 0 0 1-.3-.7z" />
    <circle cx="8.4" cy="8.4" r="1.3" />
  </>
);

export const IconLink = glyph(
  <>
    <path d="M10.5 13.5a3.5 3.5 0 0 0 5 0l2.6-2.6a3.5 3.5 0 0 0-5-5L11.8 7.3" />
    <path d="M13.5 10.5a3.5 3.5 0 0 0-5 0l-2.6 2.6a3.5 3.5 0 0 0 5 5l1.3-1.3" />
  </>
);

export const IconSearch = glyph(
  <>
    <circle cx="11" cy="11" r="6" />
    <path d="M15.5 15.5L20 20" />
  </>
);

export const IconMail = glyph(
  <>
    <rect x="3" y="5" width="18" height="14" rx="2.5" />
    <path d="M4 7.5l7.3 5a1.2 1.2 0 0 0 1.4 0l7.3-5" />
  </>
);

export const IconPhone = glyph(
  <>
    <path d="M6.4 3.8h3l1.4 3.6-2 1.5a11 11 0 0 0 5.3 5.3l1.5-2 3.6 1.4v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4.4 6a2 2 0 0 1 2-2.2z" />
  </>
);

export const IconPin = glyph(
  <>
    <path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11z" />
    <circle cx="12" cy="10" r="2.6" />
  </>
);

export const IconClock = glyph(
  <>
    <circle cx="12" cy="12" r="8" />
    <path d="M12 7.4V12l3 1.8" />
  </>
);

export const IconSpark = glyph(
  <>
    <path d="M12 3.5l1.7 4.8 4.8 1.7-4.8 1.7L12 16.5l-1.7-4.8L5.5 10l4.8-1.7z" />
    <path d="M18.5 15.5l.7 1.9 1.9.7-1.9.7-.7 1.9-.7-1.9-1.9-.7 1.9-.7z" />
  </>
);

export const IconCompass = glyph(
  <>
    <circle cx="12" cy="12" r="8" />
    <path d="M14.9 9.1l-1.6 4.2-4.2 1.6 1.6-4.2z" />
  </>
);

export const IconHeart = glyph(
  <>
    <path d="M12 19.5S4.5 15.2 4.5 9.9A3.9 3.9 0 0 1 12 8a3.9 3.9 0 0 1 7.5 1.9c0 5.3-7.5 9.6-7.5 9.6z" />
  </>
);

export const IconScale = glyph(
  <>
    <path d="M12 4.5V20M7 20h10" />
    <path d="M4 9.5h6.5L7.3 16a3.2 3.2 0 0 1-3.3-6.5zM13.5 9.5H20l-3.2 6.5a3.2 3.2 0 0 1-3.3-6.5z" />
    <path d="M12 6l7 2.4M12 6L5 8.4" />
  </>
);

export const IconLayers = glyph(
  <>
    <path d="M12 3.8l8 4.2-8 4.2-8-4.2z" />
    <path d="M4 12.4l8 4.2 8-4.2" />
    <path d="M4 16.6l8 4.2 8-4.2" />
  </>
);

export const IconPlug = glyph(
  <>
    <path d="M9 3.5v4M15 3.5v4" />
    <path d="M6.5 7.5h11v3.2a5.5 5.5 0 0 1-11 0z" />
    <path d="M12 16.2V20.5" />
  </>
);

export const IconLifebuoy = glyph(
  <>
    <circle cx="12" cy="12" r="8" />
    <circle cx="12" cy="12" r="3.3" />
    <path d="M6.4 6.4l3.3 3.3M14.3 14.3l3.3 3.3M17.6 6.4l-3.3 3.3M9.7 14.3l-3.3 3.3" />
  </>
);
